import React, { useEffect, useState } from 'react';
import { Dropdown } from 'bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import capitalize from '../../../utils/capitalize';
import AjaxSelect from '../AjaxSelect';
import { logout } from '../../../services/authService';
import { toast } from 'react-toastify';
import { footerLogo, logo } from '../../../../images';

const Header = ({ isLogo }) => {
  const navigate = useNavigate();
  const email = localStorage.getItem('email');
  const firstName = localStorage.getItem('first_name');
  const lastName = localStorage.getItem('last_name');
  const [accountOptions, setAccountOptions] = useState([]);

  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.querySelectorAll('.dropdown-toggle').forEach(dropdownToggleEl => {
      new Dropdown(dropdownToggleEl);
    });

    // document.body.classList.toggle('dark-theme', theme === 'dark');
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem('theme', theme);

    // Dispatch custom event
    window.dispatchEvent(new Event('themeChanged'));
  }, [theme]);

  const handleLogout = async () => {
    try {
      const apiRes = await logout();
      const theme = localStorage.getItem('theme');
      localStorage.clear();
      if (theme !== null) {
        localStorage.setItem('theme', theme);
      }
      toast.success(apiRes.message || 'Logged out successfully', {
        position: "bottom-right",
      })
      // navigate('/signin');
      window.location.href = '/signin';
    }
    catch (err) {
      console.error('Failed to called logout API : ', err)
    }
  };

  const toggleSidebar = () => {
    document.body.classList.toggle('toggle-sidebar');
  };

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };
  useEffect(() => {
    const handleScroll = () => {
      const header = document.getElementById("header");
      if (!header) return;

      if (window.scrollY > 0) {
        header.classList.remove("with-shadow");
      } else {
        header.classList.add("with-shadow");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on mount

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header id="header" className="header fixed-top d-flex align-items-center justify-content-between px-3">
      {/* Hamburger Icon for Mobile */}
      {!isLogo ?
        <div className="d-xl-none d-flex align-items-center">
          <i
            className="bi bi-list fs-2"
            onClick={toggleSidebar}
            style={{ cursor: 'pointer', color: '#000' }}
          ></i>
        </div> :
        <div className='p-1'>
          <img
            style={{height:'35px'}}
            src={(theme === "dark") ? footerLogo : logo}
            alt="Gapalyze Logo"
            className={(theme === "dark") ? "logo-sidebar-image-dark" : "logo-sidebar-image"}
          />
        </div>
      }

      {/* Right Section (Theme + Profile) */}
      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">
          {accountOptions !== null &&
            <li className="nav-item dropdown pe-2">
              <div style={{ minWidth: "150px" }}>
                <AjaxSelect
                  id="marketplace-select"
                  setAccountOptions={setAccountOptions}
                />
              </div>
            </li>
          }
          <li className="nav-item dropdown pe-2" onClick={toggleTheme} style={{ cursor: "pointer" }}>
            {theme === 'dark' ? (
              <i
                className="bi bi-sun theme-icon rounded-circle bg-light d-flex justify-content-center align-items-center"
                style={{
                  fontSize: '1.2rem',
                  width: '40px',
                  height: '40px',
                }}
              ></i>) : (
              <i
                className="bi bi-moon-stars theme-icon bg-light rounded-circle d-flex justify-content-center align-items-center"
                style={{
                  fontSize: '1.5rem',
                  width: '40px',
                  height: '40px',
                }}
              ></i>)}
          </li>
          {/* Profile Dropdown */}
          <li className="nav-item dropdown pe-3">
            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
              <span className="dropdown-toggle d-flex align-items-center ps-2">
                <i
                  className="bi bi-person bg-light profile-icon rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    fontSize: '1.5rem',
                    width: '40px',
                    height: '40px',
                  }}
                ></i>
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile profile-card">
              <li className="dropdown-header">
                <h6 className='kpi-heading'>
                  {firstName || lastName
                    ? `${capitalize(firstName)} ${capitalize(lastName)}`
                    : email}
                </h6>
              </li>
              <li><hr className="dropdown-divider" /></li>

              <li>
                <Link className="dropdown-item d-flex align-items-center kpi-name" to="/profile">
                  <i className="bi bi-person"></i>
                  <span>My Profile</span>
                </Link>
              </li>
              <li><hr className="dropdown-divider" /></li>

              <li>
                <a
                  className="dropdown-item d-flex align-items-center kpi-name"
                  href="logout"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <i className="bi bi-box-arrow-right"></i>
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
